import {createApp, nextTick} from 'vue';
import axios from "axios";
import {translateSpecifications} from "../../Market/js/specifications.js";


const items = document.querySelectorAll('.webien-markis-app');

items.forEach((item) => {

    let $app = createApp({
        name: "Markis-" + item.dataset.unique,
        data() {
            return {
                settings: [],
                markisApiData: {},
                defaultConfig: {},
                otherSettings: {},
                options: [],
                products: [],
                showPanel: false,
                rivieraBaseUrl: 'https://api.racke.se/v2',
                rackesApiBaseUrl: 'https://api.racke.se/v2',
                appReady: false,
                currentConf: null,
                canAddToCart: true,
                addingToCart: false,
                cartError: false,
                optionGroups: [],
                currentDetails: {
                    purchasePrice: null,
                    purchasePriceInclVat: null,
                    delivery: 'XX',
                    count: 1,
                },
                validationLoading: false,
                validationErrorMsg: null,
                validationDescr: null,
                priceSummarySticky: null,
                panel: {
                    group: null,
                    conf: null,
                },
                addingToCartText: 'Lägger i varukorg',
                addedToCartText: 'Produkten lades i varukorgen',
                addedToCart: false,
                priceValidation: {},
                draftValues: {},
                draftValueTimers: {},
                validationCount: 0,
                specialOptions: [],
                missingMarkisImages: [],
            }
        },
        mixins: [],
        computed: {
            debugMode() {
                return this.otherSettings.debug;
            },
            summary() {
                let summary = [];
                summary.push({
                    label: 'Modell',
                    value: this.otherSettings.model_name,
                    unit: '',
                })

                this.optionGroups.forEach(cat => {
                    let catOptions = this.options.filter(option => option.parentCat === cat.key);
                    catOptions.forEach(option => {
                        if (this.currentConf.values[option.id]) {
                            let displayValue = this.currentConf.values[option.id];

                            if (option.options && option.options.length > 0) {
                                let selectedOption = option.options.find(opt => opt.value === this.currentConf.values[option.id]);
                                if (selectedOption && selectedOption.label) {
                                    displayValue = selectedOption.label;
                                }
                            }

                            summary.push({
                                label: option.label,
                                value: displayValue,
                                unit: option.unit ? option.unit : '',
                            })
                        }
                    });
                });

                return summary;
            },
            deliveryText() {
                return this.rekPriceText + ' Förväntad produktionstid: ' + this.otherSettings.production_time + ' dagar';
            },
            isDefaultMarket() {
                return !window.rbMarket || window.rbMarket.currency === 'SEK';
            },
            rekPriceText() {
                let price = this.priceValidation.recommendedPriceInclVat;

                // Other markets: convert excl. VAT from SEK and add the market's VAT
                if (!this.isDefaultMarket) {
                    const converted = window.rbConvertFromSek(this.priceValidation.recommendedPrice || 0);
                    price = converted === null ? 0 : converted * (1 + window.rbMarket.vat_rate);
                }

                // Round up
                price = Math.ceil(price)

                return 'Rek. butikspris: ' + this.formatPrice(price) + '.';
            },
            // Campaign discount for the selected product code in the visitor's market, ex. 0.05 (Market\Campaign)
            campaignRate() {
                const rates = (this.otherSettings.campaigns || {})[this.otherSettings.product_code] || {};
                const locale = window.rbMarket ? window.rbMarket.locale : 'sv-SE';

                return parseFloat(rates[locale]) || 0;
            },
            // Price with campaign discount, displayed in the configurator
            priceWithMargin() {
                return Math.round(this.ordinaryPriceWithMargin * (1 - this.campaignRate) * 10000) / 10000;
            },
            priceWithMarginVat() {
                return Math.round(this.ordinaryPriceWithMarginVat * (1 - this.campaignRate) * 10000) / 10000;
            },
            ordinaryPriceWithMargin() {
                let price = this.currentDetails.purchasePrice ? this.currentDetails.purchasePrice : 0;

                // Recalculate price based on margin
                let priceMargin = this.otherSettings.price_margin ? parseFloat(this.otherSettings.price_margin) : 0;

                price = price + (price * priceMargin / 100);

                // Other markets: convert from SEK, 0 if the currency rate is missing
                if (!this.isDefaultMarket) {
                    price = window.rbConvertFromSek(price) || 0;
                }

                // Round with four decimals
                price = Math.round(price * 10000) / 10000;

                return price;
            },
            ordinaryPriceWithMarginVat() {
                // Other markets: price excl. VAT in local currency plus the market's VAT
                if (!this.isDefaultMarket) {
                    return Math.round(this.ordinaryPriceWithMargin * (1 + window.rbMarket.vat_rate) * 10000) / 10000;
                }

                // The validation API may only return the purchase price excl. VAT.
                // Preserve an explicit VAT-inclusive price when supplied.
                let price = this.currentDetails.purchasePriceInclVat
                    ?? (this.currentDetails.purchasePrice || 0) * (1 + (window.rbMarket?.vat_rate ?? 0.25));

                // Recalculate price based on margin
                let priceMargin = this.otherSettings.price_margin ? parseFloat(this.otherSettings.price_margin) : 0;

                price = price + (price * priceMargin / 100);

                // Round with four decimals
                price = Math.round(price * 10000) / 10000;


                return price;
            },
            priceText() {
                let price = this.priceWithMarginVat;


                // Round up
                price = Math.ceil(price);

                if (price === 0) {
                    return 'Pris saknas';
                }

                return this.formatPrice(price);
            },
            // Price without campaign, shown struck through when there is a campaign
            ordinaryPriceText() {
                const price = Math.ceil(this.ordinaryPriceWithMarginVat);

                if (!this.campaignRate || price === 0) {
                    return '';
                }

                return this.formatPrice(price);
            },
            imageFiles() {
                let files = [
                    {name:'stomme', filename:'xxx'},
                    {name:'kappa', filename:'xxx'},
                    {name:'bom', filename:'xxx'},
                    {name:'tacksida', filename:'xxx'},
                    {name:'vav', filename:'xxx'},
                    {name:'takprofil', filename:'xxx'},
                ];
                const format = '.avif';
                const selectedOptionText = (optionId) => {
                    const value = this.currentConf.values[optionId];
                    const option = this.options.find(option => option.id === optionId);
                    const selectedOption = option?.options?.find(opt => opt.value === value);

                    return (selectedOption?.label || value || '').toString().trim().toLowerCase();
                };

                // Layer 1 filename
                let motorType = this.currentConf.id.includes('-V') ? 'Crank' : 'Motor';
                let cleanId = this.currentConf.id.replace('-V', '').replace('-M', '').replace('R', '');
                let modelName = 'lite';
                if(cleanId === '1800') modelName = 'plus';
                if(cleanId === '1800K') modelName = 'pro';
                let color = this.options.find(option => option.id === '517' || option.id === '5306')?.options?.find(opt => opt.value === this.currentConf.values['517'] || opt.value === this.currentConf.values['5306'])?.label || 'RAL0000';
                let RAL = 'RAL' + color.replace(/\D/g, ""); // Strip to numbers only
                files[0].filename = '1-' + motorType + '-' + modelName + '-' + RAL + format

                // Layer 2 filename
                let fabricColor = this.options.find(option => option.id === '513' || option.id === '5305')?.options?.find(opt => opt.value === this.currentConf.values['513'] || opt.value === this.currentConf.values['5305'])?.label || 'Fabric0000';
                fabricColor = fabricColor.replace(/-/g, "_").replace(/[^\d_]/g, "");
                files[1].filename = '2-FabricFlap-' + modelName + '-' + fabricColor + format


                // Layer 3 filename
                files[2].filename = '3-Boom-' + modelName + '-' + RAL + format

                // Layer 4 filename
                files[3].filename = '4-ProfileSide-lite_plus' + '-' + RAL + format

                // Layer 5 filename
                files[4].filename = '5-Fabric' + '-' + modelName + '-' + fabricColor + format

                // Layer 6 filename
                files[5].filename = '6-Profile' + motorType + '-lite_plus-' + RAL + format

                if (selectedOptionText('514') === 'ej kappa') {
                    files[1].filename = 'empty.png';
                }

                if (selectedOptionText('5214') === 'nej') {
                    files[3].filename = 'empty.png';
                    files[5].filename = 'empty.png';
                }

                // Pro is built from layer 1 and 5 only
                if (modelName === 'pro') {
                    files[1].filename = 'empty.png';
                    files[2].filename = 'empty.png';
                    files[3].filename = 'empty.png';
                    files[5].filename = 'empty.png';
                }

                // Make all filenames to lower case
                files.forEach(file => {
                    file.filename = file.filename.toLowerCase();
                });

                return files;
            }
        },
        watch: {
            // Watch currentConf and validate it whenever it changes
            currentConf: {
                handler(newConf, oldConf) {
                    this.validateConf();
                    this.updateImages();
                },
                deep: true
            }
        },
        methods: {
            init() {
                console.log('Markis data:', this.markisApiData);
                this.resetDraftValues();

                this.setUpOptions();
                this.handleOptionLabels();

                this.appReady = true;


                nextTick(() => {
                    this.initPriceSummarySticky();
                    this.updateImages();

                });
            },
            updateImages() {
                let app = this;
                let imgElements = document.querySelectorAll('.image-gallery.markis .main-img');
                let imageBase = app.otherSettings.markisImgBase;
                app.missingMarkisImages = [];

                if (imgElements) {
                    imgElements.forEach(imgEl => {
                        let imgs = imgEl.querySelectorAll('img');
                        if(imgs && imgs.length > 0) {
                            imgs.forEach((img, index) => {
                                let imageFile = app.imageFiles[index];
                                if (!imageFile?.filename) {
                                    return;
                                }

                                if (!imageBase) {
                                    return;
                                }

                                // empty.png ships with the plugin, not in the uploads folder
                                let newSrc = (imageFile.filename === 'empty.png' && app.otherSettings.emptyImgUrl)
                                    ? app.otherSettings.emptyImgUrl
                                    : imageBase + imageFile.filename;
                                img.dataset.markisSrc = newSrc;
                                img.onload = () => {
                                    if (img.dataset.markisSrc === newSrc) {
                                        app.setMissingMarkisImage(imageFile.name, false);
                                    }
                                };
                                img.onerror = () => {
                                    if (img.dataset.markisSrc === newSrc) {
                                        app.setMissingMarkisImage(imageFile.name, true);
                                    }
                                };

                                if (img.src !== newSrc) {
                                    img.src = newSrc;
                                } else if (img.complete) {
                                    app.setMissingMarkisImage(imageFile.name, img.naturalWidth === 0);
                                }
                            });
                        }
                    });
                }

                app.updateMissingMarkisImageMessage();
                app.updateMarkisImageDebug();
            },

            setMissingMarkisImage(name, missing) {
                if (missing) {
                    this.missingMarkisImages = [...new Set([...this.missingMarkisImages, name])];
                } else {
                    this.missingMarkisImages = this.missingMarkisImages.filter(missingName => missingName !== name);
                }

                this.updateMissingMarkisImageMessage();
            },

            updateMissingMarkisImageMessage() {
                let messageEl = document.querySelector('.image-gallery.markis .missing-msg');
                if (!messageEl) {
                    return;
                }

                if (!this.missingMarkisImages.length) {
                    messageEl.hidden = true;
                    messageEl.textContent = '';
                    return;
                }

                messageEl.hidden = false;
                messageEl.textContent = 'Förhandsvisning saknas för: ' + this.missingMarkisImages.join(', ');
            },

            updateMarkisImageDebug() {
                let debugEl = document.querySelector('.image-gallery.markis pre.debug');
                if (!debugEl) {
                    return;
                }

                debugEl.textContent = JSON.stringify(this.imageFiles, null, 2);
            },

            setUpOptions() {

                let app = this;

                app.options = [];

                // Loop through API data and organize it into options
                if (Array.isArray(this.markisApiData?.settings?.fields)) {
                    this.markisApiData.settings.fields.forEach(field => {

                        // First, check them against fields that should be skipped
                        if (Array.isArray(app.otherSettings.groups.fields_to_hide)) {
                            app.otherSettings.groups.fields_to_hide.forEach(fieldToHide => {
                                if (field.id === fieldToHide.id) {
                                    field.skip = true;
                                }
                                // Check if the field is hidden in a inner field group
                                if (field.fields && Array.isArray(field.fields)) {
                                    field.fields.forEach(innerField => {
                                        if (innerField.id === fieldToHide.id) {
                                            innerField.skip = true;
                                        }
                                    });
                                }
                            });
                        }

                        // If Velum Pro, skip the Kappa option
                        if (['R1800K-V', 'R1800K-M'].includes(this.markisApiData.settings.product.id)) {
                            let skip = false;
                            if (Array.isArray(field.fields)) {
                                field.fields.forEach(innerField => {
                                    if (innerField.id === '514') {
                                        innerField.skip = true;
                                        skip = true;
                                    }
                                })
                                if (field.id === '514') {
                                    skip = true;
                                }
                                if (skip) {
                                    field.skip = true;
                                }
                            }
                        }


                        // If field has inner fields, loop through those and push them as options
                        if (Array.isArray(field.fields)) {
                            field.fields.forEach(innerField => {
                             if (innerField.skip) return;
                                app.pushOption(innerField);
                            })
                        } else {
                            if (field.skip) return;
                            app.pushOption(field);
                        }
                    })
                }

                // If there is a default configuration, set it as the current configuration, otherwise set current configuration to the one provided by the API or an empty configuration
                if (this.defaultConfig) {
                    this.currentConf = this.defaultConfig;
                } else if (this.markisApiData.config) {
                    this.currentConf = this.markisApiData.config
                }

                // If any of the option values are missing in currentConf, set them to the first option value or null
                this.options.forEach(option => {
                    if (!this.currentConf.values[option.id]) {
                        if (option.options && option.options.length > 0) {
                            this.currentConf.values[option.id] = option.options[0].value;
                        } else {
                            this.currentConf.values[option.id] = null;
                        }
                    }
                });

                this.options.forEach(option => {

                    // If textarea values are missing in currentConf and there is a minimum value, set them to the minimum value
                    if (!this.currentConf.values[option.id] && option.min) {
                        this.currentConf.values[option.id] = option.min;
                    }

                    // If there is a minimum value and the value is lower than the minimum, set it to the minimum
                    if (option.min && this.currentConf.values[option.id] < option.min) {
                        this.currentConf.values[option.id] = option.min;
                    }




                });



                // Add some super special fields that are not in the API but needed for the configuration
                this.addSpecialOptions();


                /*
                // If vertikalmarkis, put the group "size" as the first option group
                if(this.otherSettings.markisType === 'vertical'){
                    let sizeGroupIndex = this.optionGroups.findIndex(group => group.key === 'size');
                    if(sizeGroupIndex > -1) {
                        let sizeGroup = this.optionGroups.splice(sizeGroupIndex, 1)[0];
                        this.optionGroups.unshift(sizeGroup);
                    }
                }
                */


                console.log('Options:', this.options);

            },
            addSpecialOptions() {

                if(this.otherSettings.markisType === "terrass") {

                    this.specialOptions = ['konsol']; // Special option id:s

                    // Konsol tak/vägg
                    this.options.push({
                        id: 'custom_konsol',
                        label: 'Konsol tak/vägg',
                        subLabel: 'Välj infästning för konsolerna',
                        type: 'SelectField',
                        enabled: true,
                        options: [
                            {value: 'roof', label: 'Tak', enabled: true},
                            {value: 'wall', label: 'Vägg', enabled: true},
                        ],
                        parentCat: 'mounting',
                    });
                    // Add this option to the optino group mounting included ids
                    let mountingGroup = this.optionGroups.find(group => group.key === 'mounting');
                    if (mountingGroup) {
                        if (!mountingGroup.included_fields) {
                            mountingGroup.included_fields = [];
                        }
                        if (!mountingGroup.included_fields.find(field => field.fid === 'custom_konsol')) {
                            mountingGroup.included_fields.push({fid: 'custom_konsol'});
                        }
                    }
                    // Enable this value in the default configuration if not already set
                    if (!this.currentConf.values['custom_konsol']) {
                        this.currentConf.values['custom_konsol'] = 'roof';
                    }
                }

            },
            pushOption(field) {
                let app = this;

                let obj = {};
                let key = field.id;
                if (!key) return;

                if (field.id) obj.id = field.id;
                if (field.name) obj.label = field.name;
                if (field['@']) obj.type = field['@'];

                // Get options from validation if they exist
                let validationOptions = app.markisApiData?.settings?.validationResult?.fields?.[field.id];

                if (validationOptions && validationOptions.options) obj.options = validationOptions.options;
                if (validationOptions && validationOptions.min) obj.min = validationOptions.min;
                if (validationOptions && validationOptions.max) obj.max = validationOptions.max;

                if (validationOptions && validationOptions.instructions) obj.instructions = validationOptions.instructions.join(', ');
                if (validationOptions && validationOptions.hints) obj.hints = validationOptions.hints.join(', ');
                if (validationOptions && validationOptions.warnings) obj.warnings = validationOptions.warnings.join(', ');
                if (validationOptions && validationOptions.enabled) obj.enabled = validationOptions.enabled;
                if (validationOptions && validationOptions.readonly) obj.readonly = validationOptions.readonly;

                // Skip if not enabled
                if (!obj.hasOwnProperty('enabled')) return;

                app.options.push(obj);
            },
            showGroup(group) {
                if (group && group.key) {
                    // Look if there are any options that have the parentCat of the group and return true if there are, otherwise return false
                    let show = this.options.some(option => option.parentCat === group.key);
                    if(show && group.key === 'not_set') {
                        //Show only if debug is active
                        show = this.otherSettings.debug;
                    }
                    return show;
                }
            },
            decreaseCount() {
                if (this.currentDetails.count > 1) {
                    this.currentDetails.count--;
                }
            },
            increaseCount() {
                this.currentDetails.count++;
            },
            getDraftValue(conf) {
                if (Object.prototype.hasOwnProperty.call(this.draftValues, conf.id)) {
                    return this.draftValues[conf.id];
                }

                return this.currentConf?.values?.[conf.id] ?? '';
            },
            queueNumericConfUpdate(conf, value) {
                this.draftValues[conf.id] = value;

                if (this.draftValueTimers[conf.id]) {
                    clearTimeout(this.draftValueTimers[conf.id]);
                }

                this.draftValueTimers[conf.id] = setTimeout(() => {
                    this.commitNumericConfUpdate(conf);
                }, 1000);
            },
            commitNumericConfUpdate(conf) {
                if (this.draftValueTimers[conf.id]) {
                    clearTimeout(this.draftValueTimers[conf.id]);
                    delete this.draftValueTimers[conf.id];
                }

                let value = this.draftValues[conf.id];

                if (value === '' || value === null || typeof value === 'undefined') {
                    this.draftValues[conf.id] = this.currentConf.values[conf.id] ?? '';
                    return;
                }

                let parsedValue = parseFloat(value);
                if (Number.isNaN(parsedValue)) {
                    this.draftValues[conf.id] = this.currentConf.values[conf.id] ?? '';
                    return;
                }

                let min = conf.min !== undefined && conf.min !== null && conf.min !== '' ? parseFloat(conf.min) : null;
                let max = conf.max !== undefined && conf.max !== null && conf.max !== '' ? parseFloat(conf.max) : null;

                if ((min !== null && parsedValue < min) || (max !== null && parsedValue > max)) {
                    this.draftValues[conf.id] = this.currentConf.values[conf.id] ?? '';
                    return;
                }

                this.currentConf.values[conf.id] = parsedValue;
                this.draftValues[conf.id] = parsedValue;
            },
            resetDraftValues() {
                Object.values(this.draftValueTimers).forEach(timer => clearTimeout(timer));
                this.draftValueTimers = {};
                this.draftValues = {};
            },
            formatPrice(price) {
                if (window.rbFormatPrice) {
                    return window.rbFormatPrice(price);
                }

                return price.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
            },
            async addToCart() {
                // Guard in code as well as the button: translation adds an async
                // step, so a second click must not create another configuration.
                if (this.addingToCart || !this.canAddToCart || this.validationLoading || !this.priceWithMarginVat) {
                    return;
                }

                this.canAddToCart = false;
                this.addingToCart = true;
                this.cartError = false;
                this.addedToCart = false;

                try {
                    const body = JSON.parse(JSON.stringify({
                        action: 'add_to_cart',
                        product_name: this.otherSettings.product_name,
                        product_code: this.otherSettings.product_code || this.markisApiData.settings.product.id,
                        configuration_data: this.currentConf,
                        // Country code, currency and locale are set server side from the market
                        market_host: window.rbMarket ? window.rbMarket.host : '',
                        price_incl_vat: this.ordinaryPriceWithMarginVat,
                        price_excl_vat: this.ordinaryPriceWithMargin,
                        discount_percentage: Math.round(this.campaignRate * 10000) / 100,
                        quantity: this.currentDetails.count,
                        rivieraPrices: this.priceValidation,
                        rbuMargin: this.otherSettings.price_margin,
                        productionTime: this.otherSettings.production_time,
                        thumbUrl: this.otherSettings.thumbUrl,
                        specifications: this.validationDescr,
                    }));

                    // Snapshot all fields before waiting, so changing options
                    // during translation cannot mix different configurations.
                    body.specifications = await translateSpecifications(body.specifications, window.rbMarket?.locale);
                    const response = await axios.post(webienSite.productApi, body, { timeout: 60000 });
                    const result = response.data?.data;
                    if (response.data?.status === 'error' || !result || result.error || result.errors || result.status === 'error'
                        || !(result.cart_token || result.configuration_id || Array.isArray(result.items))) {
                        throw new Error('Cart API did not confirm the item');
                    }

                    // New cart token stays on the visitor's domain, shared with shop.
                    if (result.cart_token) {
                        const domain = '.' + window.location.hostname.replace(/^www\./, '');
                        document.cookie = 'rbu_cart_api_token=' + encodeURIComponent(result.cart_token) + '; max-age=' + (30 * 24 * 60 * 60) + '; path=/; domain=' + domain + '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
                    }
                    this.addedToCart = true;
                    setTimeout(() => {
                        this.addedToCart = false;
                    }, 2000);
                    window.dispatchEvent(new Event('refreshCart'));
                    window.scrollTo({top: 0, behavior: 'smooth'});
                } catch (error) {
                    this.cartError = true;
                    console.error('Error adding to cart.');
                } finally {
                    this.canAddToCart = true;
                    this.addingToCart = false;
                }
            },
            searchConfValues(conf) {

                let obj = {
                    value: 'XXX',
                    label: 'XXX',
                    image: '',
                    thumb_type: '',
                    hex_code: ''
                };

                if (conf.options && conf.options.length > 0) {
                    obj = {
                        ...obj,
                        ...conf.options[0]
                    };
                }

                let option = conf.options.filter((option) => option.value === this.currentConf.values[conf.id]);
                if (option && option.length > 0 && option[0].value) {
                    obj = {
                        ...obj,
                        ...option[0]
                    };
                }
                return obj;
            },
            isNumeric(str) {
                if (typeof str != "string") return false // we only process strings!
                return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
            },
            handleOptionLabels() {
                let app = this;
                // Loop options and set some labels manuelly based on type
                this.options.forEach(option => {
                    option.parentCat = 'not_set';

                    // Look for field groups and set parentCat based on that
                    this.optionGroups.forEach(group => {
                        if (group.included_fields && Array.isArray(group.included_fields)) {
                            let match = group.included_fields.find(field => field.fid === option.id);
                            if (match) {
                                option.parentCat = group.key;
                            }
                        }
                    });


                    // Special field adjustments..

                    if (['511', '5303'].includes(option.id)) { // Bredd
                        option.draggable = true;
                        option.subLabel = 'Ange bredd i cm';
                        option.max = 500;
                        option.unit = 'cm';

                        if(app.otherSettings.markisType === 'vertical'){
                            option.subLabel = 'Bredd är den totala längden på kassetten';
                        }

                        //Replace max text to 500 in instructions if it exists
                        if (option.instructions) {
                            option.instructions = option.instructions.replace(/Max är \d+/, 'Max är 500');
                        }

                    }
                    if (['512', '5304'].includes(option.id)) { // Höjd
                        option.label = 'Utfall';
                        option.subLabel = 'Utfall är den längd som markisväven kan rullas ut.';
                        option.unit = 'cm';
                        option.instructions = '';

                        if(app.otherSettings.markisType === 'vertical'){
                            option.label = 'Höjd';
                            option.subLabel = 'Höjd är den totala längden från kassettens ovansida till undersidan på styrskenor';
                            option.instructions = 'Min är 50cm, Max är 480cm.';
                        }

                        // Add all options directly and update later on api validation
                        let opts = ['150', '200', '250', '300'];
                        let extraOptions = [];
                        // Add options if they not allready exists
                        opts.forEach(opt => {
                            if (option.options && !option.options.find(o => o.value === opt)) {
                                extraOptions.push({
                                    value: opt,
                                    label: opt,
                                    enabled: false,
                                });
                            }
                        });

                        if (Array.isArray(option.options)) {
                            option.options = option.options.concat(extraOptions);
                        } else {
                            option.options = extraOptions;
                        }


                        // Add cm to all option labels if not allready added
                        option.options.forEach(opt => {
                            if (!opt.label.includes('cm')) {
                                opt.label = opt.label + ' cm';
                            }
                        });

                    }
                    if (['513', '5305'].includes(option.id)) { // Färg
                        option.subLabel = 'Färg på tyg';
                        option.usePanel = true;
                        option.options = this.otherSettings.colors.fabric;

                        // Set a default color if not set
                        if (!this.currentConf.values[option.id]) {
                            this.currentConf.values[option.id] = option.options[0].value;
                        }
                    }
                    if (['517', '5306'].includes(option.id)) { // Profiler
                        option.subLabel = 'Färg på profile';
                        option.options = this.otherSettings.colors.profile;
                        option.usePanel = true;

                        // Set a default color if not set
                        if (!this.currentConf.values[option.id]) {
                            this.currentConf.values[option.id] = option.options[0].value;
                        }
                    }
                    if (option.id === '5305') { // Väggfäste
                        option.subLabel = 'Färg';
                        option.usePanel = true;
                        option.options = this.otherSettings.colors.fabric;

                        // Set a default color if not set
                        if (!this.currentConf.values[option.id]) {
                            this.currentConf.values[option.id] = option.options[0].value;
                        }
                    }
                    if (option.id === '5214') { // Takprofil/Halvkasett
                        option.label = 'Halvkassett';
                        option.subLabel = 'Välj om markisen ska ha en halvkassett. En halvkassett skyddar den inrullade markisen från regn och sol.';
                    }

                    if (option.id === '516') { // Reg sida
                        option.label = 'Sida för Vev eller Motor';
                        option.options.forEach(opt => {
                            if (opt.label === 'V') {
                                opt.label = 'Vänster';
                            }
                            if (opt.label === 'H') {
                                opt.label = 'Höger';
                            }
                        })
                    }

                    if (option.id === '5311') { // Reg sida
                        //option.label = 'Sida för utgång av elkabel';
                        option.label = 'Sida';
                        option.options.forEach(opt => {
                            if (opt.label === 'V') {
                                opt.label = 'Vänster';
                            }
                            if (opt.label === 'H') {
                                opt.label = 'Höger';
                            }
                        })
                    }

                    if (option.id === '514') { // Kappa
                        // Include only options where label contains "Rak" or "Ej"
                        option.options = option.options.filter(opt => opt.label.includes('Rak') || opt.label.includes('Ej'));
                        // Strip away the number 10 on RAK 10 and RAK 20
                        option.options.forEach(opt => {
                            opt.label = opt.label.replace('10', '').replace('20', '').trim();
                        });
                    }

                    if (option.id === '5313') { // Reglageutgång

                        const LabelOptionArr = ['(B)', '(E)', '(ZA)', '(G)', '(ZC)'];

                        // Include only options where the label contains any allowed label fragment.
                        option.options = option.options.filter(opt =>
                            LabelOptionArr.some(labelOption => opt.label && opt.label.includes(labelOption))
                        );

                    }
                })

            },
            updateConf(conf, option) {

                // make sure options has enabled property
                if (!option.enabled) {
                    return;
                }

                this.currentConf.values[conf] = option.value;
                if (!this.currentConf.values[conf]) {
                    console.log('Cant find');
                }
                //console.log('NEW CONF:', this.currentConf.values);

                this.validateConf();
            },
            switchProduct(newProduct) {
                let details = this.otherSettings.switchOptions.options.find(option => option.id === newProduct.id);

                if (details) {
                    this.markisApiData = details.api_data;
                    this.defaultConfig = JSON.parse(details.default_config);
                    this.otherSettings.price_margin = details.price_margin;
                    this.otherSettings.model_name = details.model_name;
                    this.otherSettings.product_code = details.product_code;

                    //console.log('Switching product to', newProduct, 'with details', details);

                    this.init();
                }
            },
            selectPanelOption(option, conf) {
                this.currentConf.values[conf.id] = option.value;
                this.togglePanel();
            },

            openPanel(conf, group) {

                let app = this;
                this.panel.group = group;

                // Do some filtering on colors to see if all colors rtealy should show on this product based on ACF values
                let confOptions = conf.options;
                if (['513', '517', '5305', '5306'].includes(conf.id)) {
                    confOptions = conf.options.filter(option =>
                        option.available_for === 'all' ||
                        option.available_for === app.otherSettings.markisType ||
                        (Array.isArray(option.custom_products) && option.custom_products.includes(app.otherSettings.postId))
                    );
                }
                // Update conf
                conf.options = confOptions;

                this.panel.conf = conf;

                this.togglePanel();
            },

            togglePanel() {
                this.showPanel = !this.showPanel;

                // Set class to html element
                const htmlElement = document.documentElement;

                if (this.showPanel) {
                    htmlElement.classList.add('panelOpen');
                    setTimeout(() => {
                        htmlElement.classList.add('panelReady');
                    }, 10);
                } else {
                    htmlElement.classList.remove('panelReady');
                    setTimeout(() => {
                        htmlElement.classList.remove('panelOpen');
                    }, 300);
                }
            },
            validateConf() {
                let app = this;

                let body = {
                    'action': 'validate_conf',
                    'config': this.currentConf
                };

                this.validationLoading = true;

                this.priceValidation = {};


                // Check if we should handle anything on special options
                this.updateSpecialOptionValues();

                // Check if we have any values that should be schanged based on this conf before validation
                this.checkConfForDependentValues();

                // use axios to post currentConf to riviera API and get validation result
                axios.post(webienSite.productApi, body)
                    .then(function (response) {
                        let data = response.data.data;
                        console.log('Validation result:', data);
                        // Handle validation result, e.g. show warnings or disable options
                        if (data.valid) {
                            app.currentDetails.purchasePrice = data.purchasePrice;
                            app.currentDetails.purchasePriceInclVat = data.purchasePriceInclVat;
                            app.validationErrorMsg = null;
                            app.validationDescr = data.descriptionText;

                            app.priceValidation = {
                                purchasePrice: data.purchasePrice,
                                purchasePriceInclVat: data.purchasePriceInclVat,
                                appliedDiscount: data.appliedDiscount,
                                recommendedPrice: data.recommendedPrice,
                                recommendedPriceInclVat: data.recommendedPriceInclVat,
                            }

                            app.validationCount = 0;

                        } else {

                            let errors = data.errors;
                            let errorMsg = '';

                            // If validation error is due to height options, reset height property and validate again
                            let heightErrors = errors.filter(error => [512, 5304, 5308].includes(error.key));
                            if (heightErrors && app.validationCount < 3) {

                                // Set values to first option and validate again to reset any height options that should be disabled
                                heightErrors.forEach(error => {
                                    app.currentConf.values[error.key] = error.options[0].value;
                                });

                                // Make sure to not get stucked in a loop.
                                app.validationCount++;

                                app.validateConf();
                                return;
                            }


                            errors.forEach(error => {
                                errorMsg += 'Fält <b>' + error.key + '</b> : ' + error.error;
                            });
                            app.validationErrorMsg = 'Konfigurationen är ogiltig. Vänligen justera dina val.';
                            app.validationErrorMsg += data.errors ? ' <br>[' + errorMsg + ']' : '';
                            app.currentDetails.purchasePrice = null;
                            app.validationDescr = null;
                        }


                        // check if we should unlock or lock any height options (field 512 and 5304) based on the validation result
                        if (app.validationCount < 3 && (data.fields.hasOwnProperty('512') || data.fields.hasOwnProperty('5304'))) {
                            let heightOptions = data.fields['512'] ? data.fields['512'].options : data.fields['5304'].options;

                            if (heightOptions) {
                                // Update the current options with the new enabled/disabled state from the API
                                // if the response list is shorter than existing, just seet enabled = false on the ones that are not present in the response
                                // If thera are new options in the response that are not in the existing options, add them to the list of options
                                let existingOptions = app.options.find(option => option.id === '512' || option.id === '5304').options;

                                heightOptions.forEach(option => {
                                    let existingOption = existingOptions.find(o => o.value === option.value);
                                    if (existingOption) {
                                        existingOption.enabled = option.enabled;
                                    } else {
                                        existingOptions.push({
                                            value: option.value,
                                            label: option.label + ' cm',
                                            enabled: option.enabled,
                                        });
                                    }
                                });

                                // Enable/disable
                                app.options.forEach(option => {
                                    if (option.id === '512' || option.id === '5304') {
                                        option.options.forEach(opt => {
                                            let matchingOpt = heightOptions.find(o => o.value === opt.value);
                                            if (matchingOpt) {
                                                opt.enabled = matchingOpt.enabled;
                                            } else {
                                                opt.enabled = false;
                                            }
                                        });
                                    }
                                });

                            }

                        }



                        // Update all "kasett" values for field 5308 based on the validation result. push any new options that are not in the existing options and remove any options that are not in the validation result
                        if (data.hasOwnProperty('fields') && data.fields.hasOwnProperty('5308')) {
                            let kasettOptions = data.fields['5308'].options;
                            let existingOptions = app.options.find(option => option.id === '5308').options;

                            kasettOptions.forEach(option => {
                                let existingOption = existingOptions.find(o => o.value === option.value);
                                if (existingOption) {
                                    existingOption.enabled = option.enabled;
                                    existingOption.hide = false;

                                } else {
                                    existingOptions.push({
                                        value: option.value,
                                        label: option.label + ' mm',
                                        enabled: option.enabled,
                                        hide : false
                                    });
                                }
                            });

                            // For any options that was not in the reposnse, add a disabled property
                            existingOptions.forEach(opt => {
                                let matchingOpt = kasettOptions.find(o => o.value === opt.value);
                                if (!matchingOpt) {
                                    opt.hide = true;
                                }
                            });
                        }


                        // Populate kabel options if present (6248)
                        if (data.hasOwnProperty('fields') && data.fields.hasOwnProperty('6248')) {
                            // Push to options, first make sure it's not already there and if it is, update the options
                            let kabelOptions = data.fields['6248'].options;

                            // Always strip away "Svart 50cm Hirschman"
                            kabelOptions = kabelOptions.filter(option => option.label !== 'Svart 50cm Hirschman');

                            if(Array.isArray(kabelOptions)) {
                                let obj = {
                                    options: kabelOptions,
                                    id: '6248',
                                    label: 'Kabel',
                                    subLabel: 'Välj kabel',
                                    type: 'SelectField',
                                    enabled: true,
                                    parentCat: 'cable',
                                }

                                if(!app.options.find(option => option.id === '6248')) {
                                    app.options.push(obj);
                                }


                            }
                        }


                        // Populate Reglageutgång options if present (5313)
                        if (data.hasOwnProperty('fields') && data.fields.hasOwnProperty('5313')) {
                            // Push to options, first make sure it's not already there and if it is, update the options
                            let kabelOptions = data.fields['5313'].options;
                            if(Array.isArray(kabelOptions)) {
                                let obj = {
                                    options: kabelOptions,
                                    id: '5313',
                                    label: 'Reglageutgång',
                                    //subLabel: 'Välj kabel',
                                    type: 'SelectField',
                                    enabled: true,
                                    parentCat: 'cable',
                                }

                                let existingOptionIndex = app.options.findIndex(option => option.id === '5313');
                                if(existingOptionIndex > -1) {
                                    app.options.splice(existingOptionIndex, 1, obj);
                                } else {
                                    app.options.push(obj);
                                }


                            }
                        }



                        app.validationLoading = false;

                    })
                    .catch(function (error) {
                        console.error('Error validating configuration:', error);
                    });

            },

            checkConfForDependentValues() {
                let montage = this.options.find(option => option.id === '5315');
                if (montage) {
                    let montageValue = this.currentConf.values['5315'];
                    if(montageValue === 'Vägg') {
                        this.currentConf.values['6202'] = 'Väggmontage';
                    }
                    else if(montageValue === 'Nisch') {
                        this.currentConf.values['6202'] = 'Sidomontage';
                    }
                }
            },

            updateSpecialOptionValues() {
                // Handle Vägg/Tak konsol
                let konsolOption = this.options.find(option => option.id === 'custom_konsol');
                if (konsolOption) {
                    let konsolValue = this.currentConf.values['custom_konsol'];

                    const konsolJsonFieldIds = ['a461', 'a455', 'a787', 'a458', 'a1467', 'a462'];
                    const existingKonsolJsonFieldIds = konsolJsonFieldIds.filter(fieldId => Object.prototype.hasOwnProperty.call(this.currentConf.values, fieldId));
                    if (!existingKonsolJsonFieldIds.length) {
                        return;
                    }

                    existingKonsolJsonFieldIds.forEach(konsolJsonFieldId => {
                        // Get the json value from each available konsol field. If json parse failed, skip that field
                        let konsolJsonValue = {};
                        try {
                            konsolJsonValue = JSON.parse(this.currentConf.values[konsolJsonFieldId] || '{}');
                        } catch (e) {
                            console.error('Error parsing konsol JSON value:', e);
                            return;
                        }
                        // If konsolValue is a array get the first value
                        if (Array.isArray(konsolJsonValue)) {
                            konsolJsonValue = konsolJsonValue[0];
                        } else {
                            return;
                        }


                        if (konsolValue === 'roof') {
                            // Update the JSON value of the attribute id to roof_123
                            konsolJsonValue.id = '259210-1';
                            if (['a787', 'a1467'].includes(konsolJsonFieldId)) {
                                konsolJsonValue.id = '605110';
                            }
                        } else if (konsolValue === 'wall') {
                            konsolJsonValue.id = '259110-1';
                            if (['a787', 'a1467'].includes(konsolJsonFieldId)) {
                                konsolJsonValue.id = '605216';
                            }
                        }

                        // Set the count based on width and article
                        let width = parseFloat(this.currentConf.values['511'] || this.currentConf.values['5303']);
                        if (width < 400) {
                            konsolJsonValue.count = '2';
                        } else {
                            konsolJsonValue.count = '4';
                        }

                        // Set some special cases for theese article numbers
                        if (this.markisApiData.settings.product.id === 'R1800-K') {
                            if (width < 600) {
                                konsolJsonValue.count = '2';
                            } else {
                                konsolJsonValue.count = '3';
                            }
                        }
                        if (this.markisApiData.settings.product.id === 'R1500') {
                            if (width <= 350) {
                                konsolJsonValue.count = '2';
                            } else {
                                konsolJsonValue.count = '4';
                            }
                        }
                        if (this.markisApiData.settings.product.id === 'R1800') {
                            if (width < 330) {
                                konsolJsonValue.count = '2';
                            } else if (width >= 330 && width <= 600) {
                                konsolJsonValue.count = '4';
                            } else {
                                konsolJsonValue.count = '6';
                            }
                        }

                        // Update the current konf with the new JSON value
                        this.currentConf.values[konsolJsonFieldId] = JSON.stringify([konsolJsonValue]);

                        console.log('Updated konsol JSON value:', this.currentConf.values[konsolJsonFieldId]);
                    });
                }

            },
            initPriceSummarySticky() {
                this.destroyPriceSummarySticky();

                const container = this.$refs.markisConfig;
                const summary = this.$refs.priceSummary;
                const addToCart = this.$refs.addToCart;

                if (!container || !summary || !addToCart) {
                    return;
                }

                const state = {
                    frameId: null,
                };

                const sync = () => {
                    state.frameId = null;

                    const summaryHeight = summary.offsetHeight;
                    const summaryWidth = summary.offsetWidth;
                    const containerRect = container.getBoundingClientRect();
                    const addToCartRect = addToCart.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const stopOffset = Math.max(container.offsetHeight - addToCart.offsetTop, 0);
                    const canStick = addToCartRect.top > viewportHeight && addToCart.offsetTop > summaryHeight;

                    container.style.setProperty('--price-summary-height', `${summaryHeight}px`);

                    if (canStick) {
                        const left = Math.max(containerRect.left + container.clientWidth - summaryWidth, 0);

                        summary.classList.add('is-sticky-active');
                        summary.classList.remove('is-sticky-bottom');
                        summary.style.position = 'fixed';
                        summary.style.left = `${left}px`;
                        summary.style.right = 'auto';
                        summary.style.bottom = '0';
                        summary.style.top = 'auto';
                        summary.style.width = `${summaryWidth}px`;

                        return;
                    }

                    summary.classList.remove('is-sticky-active');
                    summary.classList.add('is-sticky-bottom');
                    summary.style.position = 'absolute';
                    summary.style.left = 'auto';
                    summary.style.right = '0';
                    summary.style.bottom = `${stopOffset}px`;
                    summary.style.top = 'auto';
                    summary.style.width = '';
                };

                const requestSync = () => {
                    if (state.frameId) {
                        return;
                    }

                    state.frameId = window.requestAnimationFrame(sync);
                };

                state.requestSync = requestSync;
                state.resizeObserver = typeof ResizeObserver !== 'undefined'
                    ? new ResizeObserver(() => {
                        requestSync();
                    })
                    : null;

                window.addEventListener('scroll', requestSync, {passive: true});
                window.addEventListener('resize', requestSync);

                if (state.resizeObserver) {
                    state.resizeObserver.observe(container);
                    state.resizeObserver.observe(summary);
                    state.resizeObserver.observe(addToCart);
                }

                this.priceSummarySticky = state;
                requestSync();
            },
            destroyPriceSummarySticky() {
                const state = this.priceSummarySticky;
                const summary = this.$refs.priceSummary;
                const container = this.$refs.markisConfig;

                if (!state) {
                    return;
                }

                window.removeEventListener('scroll', state.requestSync);
                window.removeEventListener('resize', state.requestSync);

                if (state.resizeObserver) {
                    state.resizeObserver.disconnect();
                }

                if (state.frameId) {
                    window.cancelAnimationFrame(state.frameId);
                }

                if (summary) {
                    summary.classList.remove('is-sticky-active', 'is-sticky-bottom');
                    summary.style.position = '';
                    summary.style.left = '';
                    summary.style.right = '';
                    summary.style.bottom = '';
                    summary.style.top = '';
                    summary.style.width = '';
                }

                if (container) {
                    container.style.removeProperty('--price-summary-height');
                }

                this.priceSummarySticky = null;
            },
        },
        mounted: function () {
            this.markisApiData = window['markisData_' + item.dataset.unique].json;
            this.defaultConfig = window['markisData_' + item.dataset.unique].config;
            this.otherSettings = window['markisData_' + item.dataset.unique].other;
            this.optionGroups = window['markisData_' + item.dataset.unique].other.groups.attribute_groups;

            console.log('Other settings', this.otherSettings);

            this.init();

        },
        beforeUnmount() {
            this.resetDraftValues();
            this.destroyPriceSummarySticky();
        },
        created() {

        },
        components: {},
    });

    // Mount app to DOM
    if (document.getElementById('markis-' + item.dataset.unique)) {
        $app.mount('#markis-' + item.dataset.unique);
    }

});
